import _WidgetBaseSP from 'more/_WidgetBaseSP';
import "../MonthColumnPlanTypes";
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MonthColumnPlanManager.html?raw';
import locale from 'dojo/date/locale';
import topic from 'dojo/topic';
import "dijit/ColorPalette";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../moreCore/UI/GenericDialog/GenericDialog";
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import "../../../moreCore/UI/CheckBox/CheckBox";
import DayRow from '../DayRow/DayRow';
import "../DayRow/DayRow";
import DayEditDialogForm from '../DayEditDialogForm/DayEditDialogForm';
import "../DayEditDialogForm/DayEditDialogForm";
//@ts-ignore
import MonthcolumnPlan from '../MonthColumnPlan/MonthColumnPlan';
import "../MonthColumnPlan/MonthColumnPlan";
import _TabEnabledMixin from '../../../moreCore/UI/Tabbing/_TabEnabledMixin';
//  für den template Parser ----start
import "dijit/layout/LayoutContainer";
import "dijit/layout/ContentPane";
import "dojox/widget/Calendar";

import MonthColumn from '../MonthColumn/MonthColumn';
import MonthColumnPlanGroupEditor from '../MonthColumnPlanGroupEditor/MonthColumnPlanGroupEditor';
import "../MonthColumnPlanGroupEditor/MonthColumnPlanGroupEditor";


//  für den template Parser ---- end

import MonthColumnPlanMonthPicker from '../MonthColumnPlanMonthPicker/MonthColumnPlanMonthPicker';
import "../../../moreCore/UI/Container/ExpandableSection";

//filter panel
import FilterPanel from '../../../moreCore/UI/FilterPanel/FilterPanel';
import "../../../moreCore/UI/FilterPanel/FilterPanel";
import "../../../moreCore/UI/FilterPanel/FilterPanelTypes";





interface _groupRegistryObj {
    group: MCP_group,
    days?: MdsLax<InstanceType<typeof DayRow>>[],
    color?: string,
    proiority?: number,
    concurrentGroups?: number
    appointments?: Array<{ appointment: MCP_appointment, day: MdsLax<InstanceType<typeof DayRow>> }>
}
class MonthColumnPlanManager extends compose(_WidgetBaseSP) {
    templateString: any = template;

    searchControlsContainer: HTMLElement;
    filterPanelContainer: HTMLDivElement;
    btnSubmit: HTMLButtonElement;
    //buttonSave: HTMLButtonElement;
    currentMonthDisplay: HTMLButtonElement;
    monthSelectorButton_Ok: HTMLButtonElement;
    btnSubmitLabel: HTMLSpanElement;
    currentMonthDisplay_label: HTMLSpanElement;
    resultMessageErrorContainer: HTMLElement;
    resultMessageError: HTMLElement;
    monthSelectionDialog: HTMLElement;

    monthColumnPlan: MdsLax<InstanceType<typeof MonthcolumnPlan>>;
    cb_show_event_data: MdsLax<InstanceType<typeof CheckBox>>;
    cb_show_text_data: MdsLax<InstanceType<typeof CheckBox>>;
    _dayEditDialog: MdsLax<InstanceType<typeof GenericDialog>> = null;
    dayEditdialogForm: MdsLax<InstanceType<typeof DayEditDialogForm>>;
    _lastModifiedDay: MdsLax<InstanceType<typeof DayRow>> = null;

    searchPannelMenuContainer: HTMLDivElement;
    sectionWithFilterPanel: HTMLDivElement;

    startDate: Date = null;
    _currentlyModifiedAppointment: MCP_currentlyModifiedAppointment = null;
    _allGroups: Array<{ ID: string, label: string }> = [];
    quantityMothsToDisplay: number = 2;
    maxMonthsToDisplay: number = 6;
    groupDivWidth: number = 20;// group div width in px, gebraucht um groupNode width einzustellen und in this._displayGroups();

    filterDropDownContainer: HTMLDivElement;

    // finderBase Zeug
    loadFinderConfigUrl: string = "MonthColumnPlan/GetFilterpanelOptions";
    displayedConcurrentGroups_limit: number = 5; // default // <-- unused???

    /////// vergleich/editing backup ----- start
    _lastTextAreaValue: string = "";
    _actualTextAreaValue: string = "";
    _lastGroupID: string = "";
    _groupPropertiesModified: boolean = false;
    _colorWasModified: boolean = false;
    //////// vergleich/editing backup ----- end

    // DND props ------------start
    // Kriterien für datenmanipulation zwischen loadedData und displayedData:
    _draggedGroups: Array<{ group: MCP_group, oldDays: Array<MdsLax<InstanceType<typeof DayRow>>>, newDays: Array<MdsLax<InstanceType<typeof DayRow>>> }> = [];
    _draggedAppointments: Array<{ appointment: MCP_appointment, group: string, oldDay: MdsLax<InstanceType<typeof DayRow>>, newDay: MdsLax<InstanceType<typeof DayRow>> }> = [];
    // if _isEnabled_dragAndDrop == true: modifizierte Tage aus _draggedGroups[i].newDays
    _isEnabled_dragAndDrop: boolean = false;
    _appointmentsToBeMoved: Array<MCP_appointmentToBeMoved> = [];
    _groupsToBeMoved: Array<MCP_groupToBeMoved> = [];
    _moveSubject_value: string = null;
    _movingDirection_value: string = null;
    _daysNumberToMove_value: number = null;
    _dateToMove_value: Date = null;

    // DND props ---------------end

    editable: boolean = false; // ja, es könnte isReadOnly heißen, heißt aber editable wegen der consistency across the application
    isEditable_webUserRoleName: string = "MonthColumnPlan";

    monthPickerForDlg: MdsLax<InstanceType<typeof MonthColumnPlanMonthPicker>> = null;

    //misc.
    private bookingAltColorSelectorContainer: HTMLDivElement;

    MonthScrollBar: HTMLDivElement;

    saveViewButton: HTMLButtonElement;

    storageLocationKey: string;

    menuBarContainer: HTMLDivElement;

    //Filter panel
    myFilterPanel: MdsLax<InstanceType<typeof FilterPanel>>;

    // -------------------METHODS -----------------------------------------

    private _chekcWebUserRole(): void {


        if (window.sessionInfo && window.sessionInfo.sessionData && window.sessionInfo.sessionData.Roles) {
            if (window.sessionInfo.sessionData.Roles.indexOf(this.isEditable_webUserRoleName) != -1) this.setEditable(true);
        }
        console.info("editable ", this.editable)
    }

    groupEditorWidget: MdsLax<InstanceType<typeof MonthColumnPlanGroupEditor>>;
    _onClick_editGroupMenu(ev: Event) {
        let destroyIt = true;
        if ((this.groupEditorWidget == null)) {
            destroyIt = false;
        }
        if (typeof this.groupEditorWidget == 'undefined') {
            destroyIt = false;
        }
        if (destroyIt) {
            try {
                this.groupEditorWidget.destroyRecursive();
            } catch {
                console.warn("unable to destroy editor widget");
            }
        }
        this.groupEditorWidget = new MonthColumnPlanGroupEditor();
        //this.groupEditorWidget.on("GroupDataChanged", lang.hitch(this.getAllGroups ));
        let dlg = new GenericDialog();
        dlg.closeOnEnter = false;
        dlg.closeOnEscape = false;
        dlg.setSize('larger');
        this.groupEditorWidget.myDlg = dlg;
        dlg.show(this.groupEditorWidget, this.translations["MonthColumnPlan__GroupEditor_GroupOverview"], null, null, 'close', lang.hitch(this,
            (res: any) => {
                this.monthColumnPlan.refreshDraftDataForExistingMonths();
            }
        ));
    }


    _resetAssetMovementData(): void {
        this._appointmentsToBeMoved = [];
        this._groupsToBeMoved = [];
        this._moveSubject_value = null;
        this._movingDirection_value = null;
        this._daysNumberToMove_value = null;
        this._dateToMove_value = null;
    }

    _displayGroups(): void {
        let months: Array<MdsLax<InstanceType<typeof MonthColumn>>> = this.monthColumnPlan.getAllMonths();

        for (let month of months) {
            month._displayGroups();
        }
    }

    getAllGroups(): void { // gibt nur Labels und ID's von allen gruppen die es gibt
        if (this.flagMinimalModeWasActive == true) {
            this._onGetAllGroupsResponse([]);
            return;
        }

        let url: string = window.appRoot + "MonthColumnPlan/GetAllGroups";

        this.RequestManager.post(
            url,
            {
                jsonData: null
            },
            lang.hitch(this, this._onGetAllGroupsResponse),
            lang.hitch(this, function (err) {
                console.error("ERROR: ", err);
            }),
            false // sync
        );
    }

    _onGetAllGroupsResponse(response: Array<{ ID: string, label: string }>): void {
        this._allGroups = response;
    }

    processSubscriptions(monthColumnPlan: MdsLax<InstanceType<typeof MonthcolumnPlan>>): void {

        monthColumnPlan.on("DayRow/dblClick", lang.hitch(this, function (message: { date: Date, appointment: MCP_appointment, sender: MdsLax<InstanceType<typeof DayRow>> }) {
            this.showDayEditDialog(message.sender, message.appointment);
        }));

        monthColumnPlan.on("DayRow/directValueChanged", lang.hitch(this, function (message: { modifiedAppointment: MCP_currentlyModifiedAppointment, sender: MdsLax<InstanceType<typeof DayRow>> }) {
            // message wird im MonthColumn geändert (modifiedAppointment.group properties hizugefügt)
            this.writeDirectValueDayRow(message.modifiedAppointment, message.sender);
        }));

        monthColumnPlan.on("updateGroupOrder", lang.hitch(this, function (message: { appointment: MCP_appointment, sender: MdsLax<InstanceType<typeof DayRow>> }) {
            this.getAllGroups();
            // message wird im MonthColumn geändert (modifiedAppointment.group properties hizugefügt)
            let sender = message.sender;
            let ap = message.appointment;
            let apGr: MCP_group;
            for (let gr of this._allGroups) {
                if (ap.GroupId == gr.ID) {
                    apGr = gr;
                }
            }
            if ((typeof apGr == 'undefined') || (apGr == null)) {
                apGr = {} as any;
            }
            let tmp: MCP_currentlyModifiedAppointment = {
                ID: ap.ID,
                text: ap.Description,
                date: ap.Date,
                primaryColor: ap.BackColor,
                secondaryColor: ap.TextColor,
                order: ap.order,
                group: {
                    ID: ap.GroupId,
                    description: apGr.label,
                    primaryColor: apGr.primaryColor,
                    secondaryColor: apGr.secondaryColor,
                    tooltip: apGr.tooltip,
                },
            };
            this.writeDirectValueDayRow(tmp, sender);
        }));

        monthColumnPlan.on("DayRow/dnd_drop", lang.hitch(this, function (message: { dndData: object, sender: MdsLax<InstanceType<typeof DayRow>> }) {
            this._handleDndDrop(message);
        }));

        monthColumnPlan.on("deleteApointment", lang.hitch(this, (deleteMePls: MCP_currentlyModifiedAppointment) => {
            console.warn("filtered appointments found, removal");
            console.warn(deleteMePls);
            this.deleteAppointment(deleteMePls);
        }));

        this.on("refreshStaticValues", lang.hitch(this, this.refreshStaticValues));
        monthColumnPlan.on("refreshStaticValues", lang.hitch(this, () => {
            this.refreshStaticValues();
        }));

        monthColumnPlan.on("triggerPrint", lang.hitch(this, this.triggerPrint));
    }

    private refreshStaticValues() {
        if (this.cb_show_event_data.getValue() == true) {
            this.reloadStaticAppointments();
        }
    }

    private myFilterPanelConfig: any;
    private async firstLoadFilterPanel() {
        //loadFinderConfigUrl
        this.API_get_filter_panel_config();

    }

    private _onFilterPanelResponse(panelConf) {
        this.myFilterPanelConfig = panelConf;
        this.myFilterPanel.setConfig(panelConf as any);
        this.filterPanelHelper_LoadStateFromConfig(this.saveStorage_Get());
        this.lastPanelState = this.myFilterPanel.getData(true);
        this.myFilterPanel.on("change", lang.hitch(this, this._onChange_HandleFilterPanelChange));

        if ((typeof this.myFilterPanelConfig == 'undefined') || (this.myFilterPanelConfig == null)) {
            console.error("cant load panel config?!");
            return;
        }
    }

    private lastPanelState: Object = null;
    private flagBlockFilterPanelChange = false;
    private _onChange_HandleFilterPanelChange(ev: any, forceReload = false) {
        if (this.flagBlockFilterPanelChange) {
            return;
        }
        this.flagBlockFilterPanelChange = true;
        let dat = this.myFilterPanel.getData(true);
        for (let mo of this.monthColumnPlan.getAllMonths()) {
            mo.currentFilterPanelSettings = dat;
        }
        for (let section of dat as any) {
            switch (section["_sectionName"]) {
                case 'searchParameter':
                    let searchWasChanged = false;
                    for (let comSection of this.lastPanelState as any) {
                        if (comSection["_sectionName"] == 'searchParameter') {
                            let curlist: Array<string> = [];
                            let comList: Array<string> = [];

                            for (let key in section) {
                                if ((typeof section[key] == 'boolean') || (section[key] == "")) {
                                    curlist.push(key);
                                }
                            }
                            for (let key in comSection) {
                                if ((typeof comSection[key] == 'boolean') || (comSection[key] == "")) {
                                    comList.push(key);
                                }
                            }
                            curlist.sort();
                            comList.sort();
                            if (JSON.stringify(curlist) != JSON.stringify(comList)) {
                                searchWasChanged = true;
                            }
                        }
                    }
                    if (forceReload) {
                        searchWasChanged = true;
                    }
                    if (searchWasChanged) {
                        this.lastPanelState = dat;
                        this.reloadStaticAppointments();
                    }
                    break;
                case 'appointmentColors':
                    let colValWasChanged = false;
                    for (let comSection of this.lastPanelState as any) {
                        if (comSection["_sectionName"] == 'appointmentColors') {
                            if (comSection["colorGroupSelect"] != section["colorGroupSelect"]) {
                                colValWasChanged = true;
                            }
                        }
                    }
                    if (colValWasChanged) {
                        this.lastPanelState = dat;
                        this.monthColumnPlan.requestStaticBookingColorChange(section["colorGroupSelect"]);

                    }
                    break;
            }
        }

        this.flagBlockFilterPanelChange = false;
    }

    private reloadStaticAppointments() {
        for (let month of this.monthColumnPlan.getAllMonths()) { //force clear von allen appointments
            for (let day of month.getAllDays()) {
                day.clearStaticData();
            }
        }
        this.monthColumnPlan._getBookingsList(JSON.stringify(this.myFilterPanel.getData()));//does this work?
        this.emit("dirty", false);
        this.emit("staticAppointmentsReloaded");
    }

    // DND muss übergreifend bleiben

    //// DnD -------------------------------------------------------START

    _handleDndDrop(message: { dndData: { dndId: string, dndMonth: string, dndType: "group" | "appointment" }, sender: MdsLax<InstanceType<typeof DayRow>> }): void {
        // message : {dndData: {dndId: string, dndMonth: string(widget id), dndType: "group"|"appointment"}, sender: dayRow (target)}

        //console.log("HANDLE DROP: ", message)
        if (!this.editable) return;

        let dndTargetDate: Date; // date
        let dndSourceDate: Date; // date
        let dndDayDiff: number; // number (days)
        let dndTimeDiff: number; // number (ms)
        let groupName: string;
        let appointmentText: string;
        let moveDirection: string;

        let strGroupDateStart: string;
        dndTargetDate = message.sender.date;

        let monthItemsOfPlan: Array<MdsLax<InstanceType<typeof MonthColumn>>> = this.monthColumnPlan.getAllMonths();
        for (let monthItem of monthItemsOfPlan) {
            if (monthItem.id == message.dndData.dndMonth) {
                // richtiger monat

                if (message.dndData.dndType == "group") {

                    for (let groupRegistryObj of monthItem._groupRegistry) {
                        if (groupRegistryObj.group.ID == message.dndData.dndId) {
                            //richtiger groupObj: {group: group, days: [... all group days]}

                            // uhrzeit 00:00:00 ist wichtig, sonst lokale zeitzone

                            strGroupDateStart = (groupRegistryObj.group.date_start.substring(6, 10) + "-" + groupRegistryObj.group.date_start.substring(3, 5) + "-" + groupRegistryObj.group.date_start.substring(0, 2) + "T00:00:00");

                            if (new Date(strGroupDateStart) <= monthItem.monthDate) {
                                dndSourceDate = new Date(monthItem.monthDate.valueOf());
                            } else {
                                dndSourceDate = new Date(strGroupDateStart);
                            }

                            // display werte für dialog
                            groupName = groupRegistryObj.group.label;
                        }
                    }
                } else if (message.dndData.dndType == "appointment") {

                    for (let appointmentObj of monthItem._appointmentRegistry) {
                        if (appointmentObj.appointment.ID == message.dndData.dndId) {
                            dndSourceDate = appointmentObj.day.date;
                            appointmentText = appointmentObj.appointment.Description
                            if (appointmentObj.appointment.GroupId) {
                                for (var groupObj of this._allGroups) {
                                    if (groupObj.ID == appointmentObj.appointment.GroupId) {
                                        groupName = groupObj.label;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        if (message.dndData.dndType == "group") {

            dndTimeDiff = dndTargetDate.getTime() - dndSourceDate.getTime();
            dndDayDiff = dndTimeDiff / 1000 / 60 / 60 / 24;

            if (dndDayDiff == 0) return;

            let dlg: MdsLax<InstanceType<typeof GenericDialog>> = new GenericDialog();
            dlg.destroyOnClose = true;

            this.UiModder.domStyle.set(dlg.modalDlgNode, "padding-top", "10%");

            dlg.set("TopCloseBtn", true);
            dlg.set("CancelBtn", true);
            dlg.set("YesBtn", true);

            // die description setzen texte usw
            let contentText: string = this.translations["MonthColumnPlan__DndConfirmationDialog_contentText_template"] // Platzhalter!! "Sie sind dabei die Gruppe :::GROUPNAME::: um :::DAYS::: Tage :::DIRECTION::: zu verschieben." ...

            if (dndDayDiff > 0) moveDirection = this.translations["MonthColumnPlan__DndConfirmationDialog_contentText_Direction_forward"];
            if (dndDayDiff < 0) moveDirection = this.translations["MonthColumnPlan__DndConfirmationDialog_contentText_Direction_backwards"];

            contentText = contentText.replace(":::GROUPNAME:::", "<div class=\"w3-border w3-border-gray w3-light-gray w3-panel w3-padding\">" + groupName + "</div>");
            contentText = contentText.replace(":::DAYS:::", "<span style=\"font-style: italic;\">" + String(Math.abs(dndDayDiff)) + "</span>");
            contentText = contentText.replace(":::DIRECTION:::", "<span style=\"font-style: italic;\">" + moveDirection + "</span>");
            if (Math.abs(dndDayDiff) == 1) {
                contentText = contentText.replace("Tage", "Tag");
                contentText = contentText.replace("days", "day");
            }

            this.UiModder.domAttr.set(dlg.textNode, "innerHTML", contentText);

            dlg.on("closed", lang.hitch(this, function (result) {

                if (result.result == 2) { // YES button

                    this.moveGroup(message.dndData.dndId, dndDayDiff);

                }
            }));

            dlg.show();

        } else if (message.dndData.dndType == "appointment") {

            dndTimeDiff = dndTargetDate.getTime() - dndSourceDate.getTime();
            dndDayDiff = dndTimeDiff / 1000 / 60 / 60 / 24;

            if (dndDayDiff == 0) return;

            let dlg: MdsLax<InstanceType<typeof GenericDialog>> = new GenericDialog();
            dlg.destroyOnClose = true;

            this.UiModder.domStyle.set(dlg.modalDlgNode, "padding-top", "10%");

            dlg.set("TopCloseBtn", true);
            dlg.set("CancelBtn", true);
            dlg.set("YesBtn", true);

            let contentText: string = this.translations["MonthColumnPlan__DndConfirmationDialog_contentText_template_appointment"] // Platzhalter!! "Sie sind dabei die Gruppe :::GROUPNAME::: um :::DAYS::: Tage :::DIRECTION::: zu verschieben." ...

            if (dndDayDiff > 0) moveDirection = this.translations["MonthColumnPlan__DndConfirmationDialog_contentText_Direction_forward"];
            if (dndDayDiff < 0) moveDirection = this.translations["MonthColumnPlan__DndConfirmationDialog_contentText_Direction_backwards"];

            if (groupName) {
                contentText = contentText.replace(":::GROUPNAME:::", "&lt;&lt;" + groupName + "&gt;&gt;");
            } else {
                contentText = contentText.replace("of group :::GROUPNAME::: ", "");
                contentText = contentText.replace(" der Gruppe :::GROUPNAME:::", "");
            }

            contentText = contentText.replace(":::DAYS:::", "<span style=\"font-style: italic;\">" + String(Math.abs(dndDayDiff)) + "</span>");
            contentText = contentText.replace(":::DIRECTION:::", "<span style=\"font-style: italic;\">" + moveDirection + "</span>");
            contentText = contentText.replace(":::APPOINTMENTDESCRIPTION:::", "<div class=\"w3-border w3-border-gray w3-light-gray w3-panel w3-padding\">" + appointmentText + "</div>");
            if (Math.abs(dndDayDiff) == 1) {
                contentText = contentText.replace("Tage", "Tag");
                contentText = contentText.replace("days", "day");
            }

            this.UiModder.domAttr.set(dlg.textNode, "innerHTML", contentText);

            dlg.on("closed", lang.hitch(this, function (result) {

                if (result.result == 2) { // YES button

                    this.moveAppointment(message.dndData.dndId, dndDayDiff);

                }
            }));

            dlg.show();
        }
    }

    moveGroup(groupID: string, dayDiff: number): void {

        if (!this.editable) return;

        let jsonData = { groupID: groupID, dayDiff: dayDiff }
        this.RequestManager.post(
            "MonthColumnPlan/MoveGroup",
            {
                jsonData: JSON.stringify(jsonData)
            },
            lang.hitch(this, "_onMoveGroupResponse"),
            lang.hitch(this, function (err) {
                if (err["Message"] && err["Message"] == "success") {
                    this._onMoveGroupResponse(err["Message"]);
                } else {
                    console.error("ERROR: ", err);
                }
            }),
            false // sync
        );
    }

    _onMoveGroupResponse(response): void {
        // wird nur bein move appointment, move group und delete aufgerufen - keine verzögerung hier
        this.monthColumnPlan.refreshDraftDataForExistingMonths(); // für alle monate wenn ohne parameter, sonst Array<monat>
    }

    moveAppointment(appointmentID: string, dayDiff: number): void {

        if (!this.editable) return;

        let jsonData = { appointmentID: appointmentID, dayDiff: dayDiff }
        let apiUrl = window.appRoot + "MonthColumnPlan/MoveAppointment";
        this.RequestManager.post(
            apiUrl,
            {
                jsonData: JSON.stringify(jsonData)
            },
            lang.hitch(this, "_onMoveAppointmentResponse"),
            lang.hitch(this, function (err) {
                if (err["Message"] && err["Message"] == "success") {
                    this._onMoveGroupResponse(err["Message"]);
                } else {
                    console.error("ERROR: ", err);
                }
            }),
            false // sync
        );

    }

    _onMoveAppointmentResponse(response): void {

        this.monthColumnPlan.refreshDraftDataForExistingMonths(); // für alle monate wenn ohne parameter, sonst Array<monat>
    }

    // neu angelegte Appointments und Gruppen sollen nicht verschoben verden, denn so ensteht Chaos.
    _checkForDataToBeMoved(): void {
        let skipThisCheck = !(true);

        if (!this.editable) return;

        if (this._moveSubject_value && this._currentlyModifiedAppointment && this._currentlyModifiedAppointment.ID && (((this._daysNumberToMove_value != 0) && skipThisCheck) || this._dateToMove_value)) {

            console.info("DATA TO BE MOVED: ", this._moveSubject_value, this._currentlyModifiedAppointment);

            let dayDiff: number = 0;
            if (this._movingDirection_value) {
                dayDiff = this._movingDirection_value == 'forward' ? Math.abs(this._daysNumberToMove_value) : - Math.abs(this._daysNumberToMove_value);
            }

            // wenn eine Anzahl der Tage angegeben ist
            if (dayDiff != 0) {

                // ob die Gruppe verschoben werden soll
                if (this._moveSubject_value == "group") {
                    if (this._currentlyModifiedAppointment.group && this._currentlyModifiedAppointment.group.ID) {
                        this._groupsToBeMoved.push({ groupId: this._currentlyModifiedAppointment.group.ID, dayDiff: dayDiff });
                    } else {
                        let dlg = new GenericDialog();
                        dlg.destroyOnClose = true;
                        // "Um eine Gruppe zu verschieben, wählen Sie bitte eine Gruppe im Dialog aus, oder benutzen Sie D&D."
                        dlg.show(this.translations["MonthColumnPlan__selectGrouptMessage"], "", "", "fas fa-info-circle", 'ok');
                    }
                }

                // ob das appointment verschoben werden soll, außer es wird gerade gelöscht
                if (this._moveSubject_value == "appointment") {

                    if (this._currentlyModifiedAppointment.ID && this._currentlyModifiedAppointment["text"] && this._currentlyModifiedAppointment["text"].trim() != "") {
                        this._appointmentsToBeMoved.push({ appointmentId: this._currentlyModifiedAppointment.ID, dayDiff: dayDiff });
                    } else {
                        let dlg = new GenericDialog();
                        dlg.destroyOnClose = true;
                        dlg.show(this.translations["MonthColumnPlan__selectAppointmentMessage"], "", "", "fas fa-info-circle", 'ok');
                    }

                }
            }
        }

    }

    _moveDataToBeMoved(): void {
        if (!this.editable) return;

        if (this._groupsToBeMoved.length && this._appointmentsToBeMoved.length) {
            console.error("ERROR: this._groupsToBeMoved.length && this._appointmentsToBeMoved.length. Only one of those should be true."); // weil die Gruppe auch die Appiontments bewegt
            let msg = this.translations["MonthColumnPlan__GeneralError"];
            let dlg = new GenericDialog();
            dlg.destroyOnClose = true;
            dlg.show(msg, "", "", "far fa-dizzy", 'ok');
        }
        if (this._groupsToBeMoved.length) {
            for (let groupToMove of this._groupsToBeMoved) {
                this.moveGroup(groupToMove.groupId, groupToMove.dayDiff);
            }
        } else if (this._appointmentsToBeMoved.length) {
            for (let apptToMove of this._appointmentsToBeMoved) {
                this.moveAppointment(apptToMove.appointmentId, apptToMove.dayDiff);
            }
        }

        this._resetAssetMovementData();
    }


    //// DnD -------------------------------------------------------END

    _onClick_cb_ShowTextData(evt: Event): void {
        for (let month of this.monthColumnPlan.getAllMonths()) {
            for (let day of month.getAllDays()) {
                day.emit("toggleAddTextEntry", this.cb_show_text_data.checked);
            }
        }

        if (this.cb_show_text_data.checked == false && this.cb_show_event_data.checked == false) {
            this.cb_show_text_data.set("checked", true);
            return;
        }

        this._handleVisibleColumns();
    }

    _onClick_cb_ShowEventData(evt: Event): void {

        if (this.cb_show_event_data.checked == false && this.cb_show_text_data.checked == false) {
            this.cb_show_event_data.set("checked", true);
            return;
        }

        this._handleVisibleColumns();
    }

    // parameter von den MonthColumns holen
    _handleVisibleColumns(): void {

        let event_d: boolean = this.cb_show_event_data.checked;
        let text_d: boolean = this.cb_show_text_data.checked;

        this.monthColumnPlan._handleVisibleColumns({
            event_d: event_d,
            text_d: text_d,
            groupNodeWidth: this.groupDivWidth
        });

    }

    _onClick_ButtonSortAsc(): void {
        this.monthColumnPlan.sortMonths("ASC");
    }

    _onClick_ButtonSortDesc(): void {
        this.monthColumnPlan.sortMonths("DESC");
    }

    // toolabar -----------------------------------START

    _setStartDateAttr(value: Date): void {
        this.startDate = value;
    }

    _getStartDateAttr(): Date {
        return this.startDate;
    }

    _onKeyUp_monthSelectionDialog(evt: KeyboardEvent): void {
        if (evt.code == "ArrowUp") {
            //this.monthSelector._children[0].onValueSelected(this.monthSelector._children[0]._cachedDate);
            //this.set("startDate", this.monthSelector.get("value"));
        }
    }

    _onClick_currentMonthDisplay(): void {
        if ((this.monthPickerForDlg != null) || (typeof this.monthPickerForDlg != 'undefined')) {
            try {
                this.monthPickerForDlg.destroyRecursive();
            } catch { }
        }
        this.monthPickerForDlg = new MonthColumnPlanMonthPicker(this.startDate);

        let dlg = new GenericDialog();
        dlg.destroyOnClose = true;
        dlg.show(this.monthPickerForDlg, this.translations["MonthColumnPlan__Label_AddMonth"], "", null, 'okcancel', lang.hitch(this, (res: any) => {
            if (res == 1) { //1=ok button
                let selectedValues = this.monthPickerForDlg.getSelectedValues();
                for (let val of selectedValues) {
                    //setzt den neuen monat
                    this.monthColumnPlan.addMonth(val.y, val.m);

                }
                //data refresh attempt
                this._onChange_HandleFilterPanelChange({} as any, true);
            }
        }));

    }

    // toolabar -----------------------------------END


    onDayEditDialog_Close(): void { //closingResult: <{result: number}> // 0 if cancel, 1 if ok
        if (!this.editable) return;

        // // dayRow aktualisieren
        this._currentlyModifiedAppointment = this.dayEditdialogForm._currentlyModifiedAppointment;
        this._actualTextAreaValue = this._currentlyModifiedAppointment["text"];

        console.info("DIALOG CLOSE: ", this._currentlyModifiedAppointment);
        let contVal = false;
        if (this._currentlyModifiedAppointment) {
            contVal = true;
            if (this._currentlyModifiedAppointment.ID && this._currentlyModifiedAppointment["text"] == "") {
                let dlg = new GenericDialog();
                dlg.destroyOnClose = true;
                dlg.setSize('smaller');
                dlg.show(this.translations["MonthColumnPlan__deleteAppointmentMessage"], this.translations["MonthColumnPlan__deleteAppointmentMessageHeader"], "", "fas fa-info-circle", 'okcancel', lang.hitch(this, (res) => {
                    if (res == 1) {
                        this.onDayEditDialog_CloseContinue(true);
                    } else {
                        this._currentlyModifiedAppointment["text"] = this._lastTextAreaValue;
                        this._actualTextAreaValue = this._lastTextAreaValue;
                        this.onDayEditDialog_CloseContinue(true);
                    }
                }));
            } else {
                this.onDayEditDialog_CloseContinue(contVal);
            }
        } else {
            this.onDayEditDialog_CloseContinue(contVal);
        }
    }

    onDayEditDialog_CloseContinue(contVal: boolean) {
        if (contVal == true) {
            // prufen ob eine legale gruppe vorliegt

            if (this._currentlyModifiedAppointment.group) {
                if (this._currentlyModifiedAppointment.group.description == null && this._currentlyModifiedAppointment.group.ID) {

                    // wenn kein Name definiert war - geben wir einen
                    this._currentlyModifiedAppointment.group.description = "RG_" + Math.floor(Math.random() * 99999); // RG_12345 z.B.

                    let msg: string = this.translations["MonthColumnPlan__groupNameMessage"];
                    msg.replace(":::groupName:::", this._currentlyModifiedAppointment.group.description);
                    let dlg = new GenericDialog();
                    dlg.destroyOnClose = true;
                    dlg.show(msg, "", "", "fas fa-info-circle", 'ok');
                }

                if (typeof this._currentlyModifiedAppointment.group.ID == 'string') {
                    if (false && this._currentlyModifiedAppointment.group.primaryColor == null && ((this._currentlyModifiedAppointment.group.ID != null) || (typeof this._currentlyModifiedAppointment.group.ID != 'undefined'))) {
                        //disabled code block
                        this._currentlyModifiedAppointment.group.primaryColor = "#ff8000";
                        let dlg = new GenericDialog();
                        dlg.destroyOnClose = true;
                        dlg.show(this.translations["MonthColumnPlan__groupColorMessage"], "", "", "fas fa-info-circle", 'ok');
                    }
                }
                if (this._currentlyModifiedAppointment.group.primaryColor == null && this._currentlyModifiedAppointment.group.description == null) {
                    this._currentlyModifiedAppointment.group = null;
                }
            } else {
                this._currentlyModifiedAppointment.group = null;
            }

            this._checkForDataToBeMoved();

            if (typeof this._actualTextAreaValue == 'undefined') {
                return;
            }
            if (this._actualTextAreaValue == null) {
                return;
            }

            if (this._actualTextAreaValue.replace(/(?:\r\n|\r|\n|<br>)/g, '\r\n') != this._lastTextAreaValue) {
                this.writeDirectValueDayRow(this._currentlyModifiedAppointment, this._lastModifiedDay);
            } else {

                if (this._currentlyModifiedAppointment.group && this._currentlyModifiedAppointment.group.description && this._currentlyModifiedAppointment.group.ID == null) {
                    // d.h. gruppe warde neu angelegt
                    this.writeDirectValueDayRow(this._currentlyModifiedAppointment, this._lastModifiedDay);
                } else if (this._currentlyModifiedAppointment.group) {
                    // Gruppe des appointments wurde geändert

                    if (this._currentlyModifiedAppointment.group.ID != this._lastGroupID || this._groupPropertiesModified) {
                        this.writeDirectValueDayRow(this._currentlyModifiedAppointment, this._lastModifiedDay);
                    }

                } else {
                    //nothing has changed
                }
            }

        }

        this._moveDataToBeMoved();

        this._groupPropertiesModified = false;

        //check ob die farbe geupdated werden soll
        if (this._colorWasModified) {
            this.writeDirectValueDayRow(this._currentlyModifiedAppointment, this._lastModifiedDay);
        }

        //refresh data
        let curYear = this._currentlyModifiedAppointment.date.split("-")[0];
        let curMonth = this._currentlyModifiedAppointment.date.split("-")[1];
        if ((typeof curYear == 'undefined') || (curYear == null)) {
            if ((typeof curMonth == 'undefined') || (curMonth == null)) {
                return;
            }
        }
        try {
            this.monthColumnPlan.getMonth(curYear as any, curMonth as any).refreshDayRows(); //laded die display values neu
        } catch (err) {
            console.error(err);
        }

    }

    writeDirectValueDayRow(modifiedAppointment: MCP_currentlyModifiedAppointment, DayRow: any): void {
        if (!this.editable) return;

        // dayRow aktualisieren:
        let modAppt_groupId: string = null;
        if (modifiedAppointment.group && modifiedAppointment.group.ID) {
            modAppt_groupId = modifiedAppointment.group.ID;
        }

        let appointment: MCP_appointment = {
            ID: modifiedAppointment.ID,
            Classname: "appointment_draft",
            Type: "draft",
            "Date": modifiedAppointment.date,
            Description: modifiedAppointment["text"],
            GroupId: modAppt_groupId,
            BackColor: modifiedAppointment.primaryColor,
            TextColor: modifiedAppointment.secondaryColor,
            Tooltip: ""
        }

        let isGroupId: boolean = false;
        let isGRoupDescription: boolean = false;

        if (modifiedAppointment["text"]) {
            modifiedAppointment["text"].replace(/(?:\r\n|\r|\n|<br>)/g, '\r\n');

        }

        if (modifiedAppointment.group) {
            if (modifiedAppointment.group.description) {
                modifiedAppointment.group.description.replace(/(?:\r\n|\r|\n|<br>)/g, '\r\n');
                isGRoupDescription = true;
            }
            if (modifiedAppointment.group.ID) {
                isGroupId = true;
            }

        } else {
            modifiedAppointment.group = null;
        }

        if (isGroupId == false && isGRoupDescription == false) {
            modifiedAppointment.group = null;
        }

        this._lastModifiedDay = DayRow; // nur für den nächsten fetchDayRowData, damit wir nicht alle tage laden müssen, wird im anschluss frei gemacht

        DayRow.updateAppointments(appointment); // wenn der Text null ist oder "" wird das appointment aus der day._appointments entfernt

        if (modifiedAppointment.ID) {

            if (modifiedAppointment["text"] == "" || modifiedAppointment["text"] == null) {

                this.deleteAppointment(modifiedAppointment);
                return;
            }
        }
        //hotfix colors for group
        let hasGroup = true;
        if (typeof modifiedAppointment.group == 'undefined') {
            hasGroup = false;
        }
        if (hasGroup == true) {
            if (modifiedAppointment.group == null) {
                hasGroup = false;
            }
        }
        if (hasGroup == true) {
            if (typeof modifiedAppointment.group.ID == 'undefined') {
                hasGroup = false;
            }
            if (hasGroup == true) {
                if (modifiedAppointment.group.ID == null) {
                    hasGroup = false;
                }
            }
        }

        if (hasGroup) {
            for (let gr of this._allGroups as any as Array<MCP_group>) {
                if (gr.ID == modifiedAppointment.group.ID) {
                    modifiedAppointment.group.primaryColor = gr.primaryColor;
                    modifiedAppointment.group.secondaryColor = gr.secondaryColor;
                }
            }
        }

        this.writeRowData(modifiedAppointment);

    }

    deleteAppointment(appointment: MCP_currentlyModifiedAppointment): void {
        if (!this.editable) return;

        if (appointment && appointment.ID) {

            let url: string = window.appRoot + "MonthColumnPlan/DeleteDayRowData";

            this.RequestManager.post(
                url,
                {
                    jsonData: JSON.stringify({ ID: appointment.ID, Classname: "appointment_draft", })
                },
                lang.hitch(this, "_onDeleteAppointmentResponse", appointment),
                lang.hitch(this, function (err) {
                    if (err["Message"] && err["Message"] == "success") {
                        this._onDeleteAppointmentResponse(appointment, err["Message"]);
                        return;
                    }
                    console.error("ERROR: ", err);
                }),
                false // sync
            );
        } else {
            let dlg = new GenericDialog();
            dlg.destroyOnClose = true;
            dlg.show(this.translations["MonthColumnPlan__GeneralError"], "", "", "fas fa-info-circle", 'ok');
            console.error("deleteDayRowData:: invalid parameter");
        }
    }

    private API_get_filter_panel_config(): void {
        let apiURL = window.appRoot + this.loadFinderConfigUrl;

        this.RequestManager.get(apiURL,
            lang.hitch(this, this._onFilterPanelResponse),
            (error) => {
                console.error("error on API_get_filter_panel_config", error);
            }
        );

    }

    _onDeleteAppointmentResponse(appointment: MCP_appointment, response: string): void {

        if (response == "success") {

            //parameter for request
            let monthItem: MdsLax<InstanceType<typeof MonthColumn>> = this.monthColumnPlan.getMonthByDayRow(this._lastModifiedDay);
            let monthDays: Array<MdsLax<InstanceType<typeof DayRow>>> = [];
            monthDays.push(this._lastModifiedDay);
            let sType = "draft"; // for now

            monthItem.fetchMultipleDayRowData(monthDays, sType);
            monthItem.fetchGroupData(monthItem._dayRegistry);

            //this._setSaveButtonState(true);

        } else {
            console.error("ERROR: ", response);
        }
        //es wird nocheinmal ein refresh ausgeloest, weil wenn ein appointment zu einer gruppe zaehlt, das mehr als 1 appointment hat
        //wird der termin im client nicht sauber geloescht und noch angezeigt, obwohl es im backend bereits weg ist
        this.monthColumnPlan.refreshDraftDataForExistingMonths();
    }

    writeRowData(appointment: MCP_currentlyModifiedAppointment): void {
        if (!this.editable) return;
        //fix farben
        if (typeof appointment.primaryColor == 'undefined') {
            appointment.primaryColor = "~000000";
        }
        if (appointment.primaryColor == null) {
            appointment.primaryColor = "~000000";
        }
        if (appointment.primaryColor == "") {
            appointment.primaryColor = "~000000";
        }
        if (appointment.primaryColor == " ") {
            appointment.primaryColor = "~000000";
        }

        if (typeof appointment.secondaryColor == 'undefined') {
            appointment.secondaryColor = "~000000";
        }
        if (appointment.secondaryColor == null) {
            appointment.secondaryColor = "~000000";
        }
        if (appointment.secondaryColor == "") {
            appointment.secondaryColor = "~000000";
        }
        if (appointment.secondaryColor == " ") {
            appointment.secondaryColor = "~000000";
        }

        console.info("writeRowData: appt:: ", appointment);

        let url = window.appRoot + "MonthColumnPlan/WriteDayRowData";

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(appointment)
            },
            lang.hitch(this, "_onWriteRowData_response"),
            lang.hitch(this, function (err) {
                if (err["Message"] && err["Message"] == "success") {
                    this._onWriteRowData_response(err["Message"]);
                    return;
                }
                console.error("ERROR: ", err);
            }),
            false // sync
        );

    }

    // wird durch die topic subscription getriggert
    _onWriteRowData_response(response: string): void {

        if (response == "success") {
            this.getAllGroups();

            //this._setSaveButtonState(true);

            //parameter for request
            let monthItem: MdsLax<InstanceType<typeof MonthColumn>> = this.monthColumnPlan.getMonthByDayRow(this._lastModifiedDay);
            let monthDays: Array<MdsLax<InstanceType<typeof DayRow>>> = [];
            monthDays.push(this._lastModifiedDay);
            let sType = "draft"; // for now

            monthItem.fetchMultipleDayRowData(monthDays, sType);
            monthItem.fetchGroupData(monthItem._dayRegistry);
        }

    }

    deleteGroup(grouID: string): void {
        if (!this.editable) return;

        let IDlist: Array<string> = [];
        IDlist.push(grouID);

        let json_value = JSON.stringify({ targetClassname: "appointment_draft_group", IDlist: IDlist });


        let url: string = window.appRoot + "MonthColumnPlan/DeleteGroup";

        this.RequestManager.post(
            url,
            {
                jsonData: json_value
            },
            lang.hitch(this, "_onDeleteGroup_response", grouID),
            lang.hitch(this, function (err) {
                if (err["Message"] && err["Message"] == "success") {
                    this._onDeleteGroup_response(grouID, err["Message"]);
                    return;
                }
                console.error("ERROR: ", err);
            }),
            false // sync
        );

    }

    _onDeleteGroup_response(groupId: string, response: string): void {
        if (response == "success") {
            this.getAllGroups();
            this.monthColumnPlan.refreshDraftDataForExistingMonths(); // für alle monate wenn ohne parameter, sonst Array<monat>
            //this._setSaveButtonState(true);
        } else {
            console.error("group not deleted: ", JSON.parse(response));
            let dlg = new GenericDialog();
            dlg.destroyOnClose = true;
            dlg.show(response, "", "", "fas fa-info-circle", 'ok');
        }
    }

    showDayEditDialog(dayRow: MdsLax<InstanceType<typeof DayRow>>, appointment: MCP_appointment): void {
        if ((typeof appointment == 'undefined') || (appointment == null)) {
            return;
        }
        if (!this.editable) return;

        /// alles resetten
        if (this.dayEditdialogForm != null) {
            this.dayEditdialogForm = null;
        }
        if (this._dayEditDialog != null) {
            this._dayEditDialog = null;
        }

        this._lastModifiedDay = dayRow;

        // backups für den vergleich
        if (appointment && appointment.Description) this._lastTextAreaValue = appointment.Description;
        if (appointment && appointment.GroupId) this._lastGroupID = appointment.GroupId;

        this._dayEditDialog = new GenericDialog();
        this._dayEditDialog.destroyOnClose = false;

        this._dayEditDialog.setCloseOnEnter(false);

        this._dayEditDialog.set("header", this.translations["MonthColumnPlan__advancedAppointmentEditMenu"]);

        this._dayEditDialog.set("TopCloseBtn", true);

        this._dayEditDialog.set("OkBtn", true);
        this._dayEditDialog.set("CancelBtn", true);

        this._dayEditDialog.on("closed", lang.hitch(this, function (result) {
            this.getAllGroups();
            this.monthColumnPlan.refreshDraftDataForExistingMonths();
            if (result.result == 1) { // ok button

                setTimeout(lang.hitch(this, "onDayEditDialog_Close"), 300);

            } else {
                this.modifiedAppointment = null;
                this._dayEditTextArea_value = "";
            }
        }));

        // AnzeigeDAtum für das label
        let strDisplayDayDate: string = locale.format(dayRow.date, {
            selector: "date",
            datePattern: "dd MMMM yyyy | EEE"
        });
        this._dayEditDialog.set("subTitle", strDisplayDayDate);
        this._colorWasModified = false;
        this.dayEditdialogForm = new DayEditDialogForm(dayRow.date, appointment, this._allGroups, [...this.monthColumnPlan.getMonthByDayRow(dayRow)._groupRegistry]);
        this.dayEditdialogForm.on("GroupDataChanged", lang.hitch(this, this.getAllGroups));
        this._addDialogFormListeners(this.dayEditdialogForm);
        this._dayEditDialog.addButton("deleteAppointmentButton",
            this.translations["MonthColumnPlan__AppointmentEditor_RmButton"],
            lang.hitch(this, () => {
                this.dayEditdialogForm._currentlyModifiedAppointment["text"] = "";
                this.onDayEditDialog_Close();
            }),
            this.translations["MonthColumnPlan__AppointmentEditor_RmButton_Toolbar"],
            "mds-button-base w3-red hoverBright",
            "far fa-trash-alt warningTXT",
            true,
            'last',
            true
        );
        this._dayEditDialog.on("groupWasUpdated", lang.hitch(this, () => {
            this.getAllGroups();
            for (let month of this.monthColumnPlan.getAllMonths()) {
                month._clearAllRails();
                month.removeAllDays();
                month.refreshDayRows();
            }
        }));
        this.dayEditdialogForm.placeAt(this._dayEditDialog.textNode);
        this.dayEditdialogForm.myGenericDialog = this._dayEditDialog;
        this._dayEditDialog.show();
        this.dayEditdialogForm._onShow_dlg();
    }

    _addDialogFormListeners(dialogForm: MdsLax<InstanceType<typeof DayEditDialogForm>>): void {
        dialogForm.on("dayEditDialogForm/deleteGroup", lang.hitch(this, function (groupID) {
            this.deleteGroup(groupID);
            this._dayEditDialog.hide();
        }));
        dialogForm.on("dayEditDialogForm/lastTextAreaValueChange", lang.hitch(this, function (value) {
            this._lastTextAreaValue = value; //no references found???
        }));
        dialogForm.on("dayEditDialogForm/groupPropertiesModified", lang.hitch(this, function () {
            this._groupPropertiesModified = true;
        }));
        dialogForm.on("dayEditDialogForm/moveSubject_value", lang.hitch(this, function (value: string) {
            this._moveSubject_value = value;
        }));
        dialogForm.on("dayEditDialogForm/movingDirection_value", lang.hitch(this, function (value: string) {
            this._movingDirection_value = value;
        }));
        dialogForm.on("dayEditDialogForm/daysNumberToMove_value", lang.hitch(this, function (value: number) {
            this._daysNumberToMove_value = value;
        }));
        dialogForm.on("dayEditDialogForm/dateToMove_value", lang.hitch(this, function (value: Date) {
            this._dateToMove_value = value;
        }));
        dialogForm.on("dayEditDialogForm/color_updated", lang.hitch(this, () => {
            this._colorWasModified = true;
        }));
    }

    _onClick_ButtonSave(evt: Event): void {
        //
        //	nur Dummy-Funktion. Muss nichts machen. Solange der Button fokusiert werden kann, macht das onBlur in der DayRow den Speichervorgang
        //
    }


    flagAfterPrintRestoreDarkTheme = false;
    restoreDocumentTitle: string = "";
    triggerPrint(evt: Event): void {
        //dark theme ausblenden beim printen
        let target = document.getElementsByTagName("body")[0]
        if (target.classList.contains("darkTheme") == true) {
            this.flagAfterPrintRestoreDarkTheme = true;
            target.classList.remove("darkTheme");
        }
        //fix 4 border
        let ptarget = this.domNode.getElementsByClassName("mainPrintContainer")[0];
        if (ptarget.classList.contains("sectionBG") == true) {
            ptarget.classList.remove("sectionBG");
        }
        this.restoreDocumentTitle = document.title;
        document.title = window.translations["NavigationTile__MonthColumnPlan"]; //setzt anderen title, da bei print-to-pdf der html doc title als pdf title verwendet wird
        let monthColumns = this.domNode.getElementsByClassName("monthColumn");
        for (let mc of monthColumns as any as Array<HTMLElement>) {
            if (mc.classList.contains("hideOnPrint") == false) {
                if (mc.classList.contains("printMe") == false) {
                    mc.classList.add("hideOnPrint");
                }
            }
        }
        //print
        window.print();
    }

    _onAfterPrint(ev: Event) {
        //aktiviert das dark theme wieder, sollte das eingeschalten verwendet worden sein
        if (this.flagAfterPrintRestoreDarkTheme == true) {
            this.flagAfterPrintRestoreDarkTheme = false;
            let target = document.getElementsByTagName("body")[0]
            if (target.classList.contains("darkTheme") == false) {
                target.classList.add("darkTheme");
            }
        }
        let target = this.domNode.getElementsByClassName("mainPrintContainer")[0];
        if (target.classList.contains("sectionBG") == false) {
            target.classList.add("sectionBG");
        }
        document.title = this.restoreDocumentTitle;
        let monthColumns = this.domNode.getElementsByClassName("monthColumn");
        for (let mc of monthColumns as any as Array<HTMLElement>) {
            if (mc.classList.contains("hideOnPrint") == true) {
                mc.classList.remove("hideOnPrint");
            }
            if (mc.classList.contains("printMe") == true) {
                mc.classList.remove("printMe");
            }
        }
    }

    setDefaultStartDate(): void {

        //	Datum korrigierem
        //
        this.startDate.setDate(1);
        this.startDate.setHours(0);
        this.startDate.setMinutes(0);
        this.startDate.setSeconds(0);

        this.monthColumnPlan.removeAllMonths();
        //check view von local storage
        //local storage check
        let savedViewConfig: MonthColumnPlan_LocalStorageConfig = this.saveStorage_Get();
        if (savedViewConfig.defaultView == true) {
            this.monthColumnPlan.addMonthRange(this.startDate, this.quantityMothsToDisplay);
        } else {
            for (let m of savedViewConfig.months) {
                this.monthColumnPlan.addMonth(m.y, m.m, true);
            }
        }

        this._handleVisibleColumns();

        this.emit("dirty", true);
        //this.setSubmitButtonStyles();
    }

    private filterPanelHelper_SaveStateToConfig(conf: MonthColumnPlan_LocalStorageConfig): MonthColumnPlan_LocalStorageConfig {
        let newConf = conf;
        let tickedEntrysGroup: Array<string> = [];
        let tickedEntrysColor: string = "";
        let fpDat: Array<object> = this.myFilterPanel.getData(true) as any;
        for (let entry of fpDat) {
            switch (entry["_sectionName"]) {
                case "searchParameter": //searchParameter = Static Appointment type
                    for (let key in entry) {
                        if ((typeof entry[key] === 'boolean') || ((entry[key] == ""))) { //pre-select ist aus irgend ein grund "" statt bool .-.
                            tickedEntrysGroup.push(key);
                        }
                    }
                    break;
                case "appointmentColors":
                    tickedEntrysColor = entry["colorGroupSelect"];
                    break;
            }
        }
        newConf["filterPanelState"] = {
            searchParameter: tickedEntrysGroup,
            colorGroupSelect: tickedEntrysColor,
        };
        return newConf;
    }
    private filterPanelHelper_LoadStateFromConfig(conf: MonthColumnPlan_LocalStorageConfig): void {
        if (this.saveStorage_HasKey("filterPanelState") == false) {//erstes belegen von daten
            let tmpFirstSaveConf = this.filterPanelHelper_SaveStateToConfig(conf);
            this.saveStorage_OverWrite(tmpFirstSaveConf);
            return this.filterPanelHelper_LoadStateFromConfig(conf);//recrusive call
        }
        if (this.myFilterPanelConfig) {
            for (let section of this.myFilterPanelConfig["sections"]) {
                switch (section["name"]) {
                    case 'searchParameter':
                        for (let options of section["options"]) {
                            let wasFound = false;
                            for (let check of conf["filterPanelState"]["searchParameter"]) {
                                if (check == options["name"]) {
                                    wasFound = true;
                                }
                            }
                            if (wasFound == true) {
                                options["selected"] = true;
                            } else {
                                options["selected"] = false;
                            }
                        }
                        break;
                    case 'appointmentColors':
                        for (let options of section["options"]) {
                            if (options["name"] == "colorGroupSelect") {
                                let optionWasSet = false;
                                for (let values of options["valueList"]) {
                                    if (values["value"] == conf.filterPanelState.colorGroupSelect) {
                                        values["selected"] = true;
                                        optionWasSet = true;
                                    } else {
                                        values["selected"] = false;
                                    }
                                }
                                if (optionWasSet) {
                                    options["value"] = conf.filterPanelState.colorGroupSelect;
                                }
                            }
                        }
                        break;
                }
            }
        }
        //this.myFilterPanel.destroyRecursive(); //<- kann nicht destroy'n. guess we memory leak a bit.
        this.myFilterPanel = new FilterPanel();
        this.searchPannelMenuContainer.innerHTML = "";
        this.myFilterPanel.placeAt(this.searchPannelMenuContainer);
        this.lastPanelState = this.myFilterPanel.getData(true);
        this.myFilterPanel.setConfig(this.myFilterPanelConfig);
        //this.myFilterPanel.on("change", lang.hitch(this, this._onChange_HandleFilterPanelChange));
        this._onChange_HandleFilterPanelChange(null);
        this.reloadStaticAppointments();
    }

    private saveStorage_ResetConfig() {
        let defaultConfig: MonthColumnPlan_LocalStorageConfig = {
            defaultView: true,
            filterPanelState: {
                searchParameter: ["000000fd:00000005"],
                colorGroupSelect: "ev_activity_status",
            }
        };

        localStorage.setItem(this.storageLocationKey, JSON.stringify(defaultConfig));
        this.filterPanelHelper_LoadStateFromConfig(this.saveStorage_Get());
    }

    private saveStorage_Get(): MonthColumnPlan_LocalStorageConfig {
        let savedViewJson = localStorage.getItem(this.storageLocationKey);
        if (typeof savedViewJson != 'string') {
            this.saveStorage_ResetConfig();
            savedViewJson = localStorage.getItem(this.storageLocationKey);
        }
        return JSON.parse(savedViewJson);
    }

    private saveStorage_HasKey(key: string): boolean {
        let conf = this.saveStorage_Get();
        if (conf.hasOwnProperty(key)) {
            return true;
        }
        return false;
    }

    private saveStorage_OverWrite(config: MonthColumnPlan_LocalStorageConfig) {
        //uberschreib gesetzte werte aus dem uebergebenen config objekt
        let orgiConfig = this.saveStorage_Get(); //wird ueberschrieben
        for (const key in config) {
            if (config.hasOwnProperty(key)) {
                orgiConfig[key] = config[key];
            }
        }
        localStorage.setItem(this.storageLocationKey, JSON.stringify(orgiConfig));
    }

    private _onClick_ButtonSaveView() {
        let confirmDlg = new GenericDialog();
        confirmDlg.show(
            this.translations["MonthColumnPlan___SaveView_ConfirmDlg_Body"],
            this.translations["MonthColumnPlan___SaveView_ConfirmDlg_Header"],
            null,
            "far fa-save",
            'yesno',
            lang.hitch(this, (res: Number) => {
                if (res == 2) {
                    let saveConf: MonthColumnPlan_LocalStorageConfig = this.saveStorage_Get();
                    saveConf.defaultView = false;
                    saveConf["months"] = []; //reset
                    for (let month of this.monthColumnPlan.getAllMonths()) {
                        saveConf.months.push({
                            y: month.getCurrentYear(),
                            m: month.getCurrentMonth(),
                        });
                    }
                    saveConf = this.filterPanelHelper_SaveStateToConfig(saveConf);
                    this.saveStorage_OverWrite(saveConf);
                    this.filterPanelHelper_LoadStateFromConfig(this.saveStorage_Get());
                    this.showToast(this.translations["MonthColumnPlan___SaveView_Confirmation"], "fas fa-bookmark");
                }
            })
        );
    }

    private _onClick_ButtonResetView() {
        let confirmDlg = new GenericDialog();
        confirmDlg.show(
            this.translations["MonthColumnPlan___ResetView_ConfirmDlg_Body"],
            this.translations["MonthColumnPlan___ResetView_ConfirmDlg_Header"],
            null,
            "fas fa-undo",
            'yesno',
            lang.hitch(this, (res) => {
                if (res == 2) {
                    let todayDate = new Date();
                    this.monthColumnPlan.removeAllMonths();
                    this.monthColumnPlan.addMonth(todayDate.getFullYear(), todayDate.getMonth(), true);
                    todayDate.setMonth(todayDate.getMonth() + 1);
                    this.monthColumnPlan.addMonth(todayDate.getFullYear(), todayDate.getMonth(), true);
                    this.saveStorage_ResetConfig();
                    this.showToast(this.translations["MonthColumnPlan___ResetView_Confirmation"], "fas fa-undo");
                }
            }),
        );
    }


    _setAppointmentStyle(appointmentObj: { appointment: MCP_appointment, day: MdsLax<InstanceType<typeof DayRow>> }): void {

        let dayRowWidget: MdsLax<InstanceType<typeof DayRow>> = appointmentObj.day;
        dayRowWidget.updateAppointments(appointmentObj.appointment);
    }

    delegateClick_ToContentNode(dayWidget): void {

        let dblclick_event: MouseEvent = new MouseEvent('dblclick', {
            'view': window,
            'bubbles': true,
            'cancelable': true
        });
        dayWidget.valueNode.dispatchEvent(dblclick_event);

    }


    // ----------------------------------------------------get & set

    setMaxMonthsToDisplay(months: number): void {

        months = Math.abs(months);
        this.maxMonthsToDisplay = months;
        if (this.monthColumnPlan) this.monthColumnPlan.maxMonthsToDisplay = months + 99;

    }
    _setMaxMonthsToDisplayAttr(months: number): void {

        this.setMaxMonthsToDisplay(months);

    }
    setQuantityMothsToDisplay(months: number): void {

        months = Math.abs(months);
        this.quantityMothsToDisplay = months;
        if (this.monthColumnPlan) this.monthColumnPlan.quantityMothsToDisplay = months;

    }
    _setQuantityMothsToDisplayAttr(months: number): void {

        this.setQuantityMothsToDisplay(months);

    }

    setEditable(bool: boolean): void {
        this.editable = bool;
        this.monthColumnPlan.set("editable", this.editable);
    }
    _setEditablAttr(bool: boolean): void {
        this.setEditable(bool);
    }

    _onClick_ButtonIncrsMonths() {
        for (let month of this.monthColumnPlan.getAllMonths()) {
            month._onclickMonthHeaderDown();
        }
    }
    _onClick_ButtonDecrsMonths() {
        for (let month of this.monthColumnPlan.getAllMonths()) {
            month._onclickMonthHeaderUp();
        }
    }

    _onClick_ButtonAddMonthToLeft() {
        let lowestYear = 9999;
        let lowestMonth = 99;
        //allgemeiner reminder fuer mich selber: in js fangen monate mit 0 an
        for (let cMonth of this.monthColumnPlan.getAllMonths()) { //wir suchen zuerst das jahr, dann den monat
            if ((cMonth.getCurrentYear() <= lowestYear)) {
                if (cMonth.getCurrentYear() < lowestYear) {
                    lowestYear = cMonth.getCurrentYear();
                }
            }
        }
        for (let cMonth of this.monthColumnPlan.getAllMonths()) {
            if ((cMonth.getCurrentYear() == lowestYear)) {
                if ((cMonth.getCurrentMonth() < lowestMonth)) {
                    lowestMonth = cMonth.getCurrentMonth();
                }
            }
        }
        if (lowestMonth == 99) {
            console.warn("keine monate in liste");
            return;
        }
        //wir berechnen das neue monat und fuegen es hinzu
        if (lowestMonth == 0) {
            lowestMonth = 11;
            lowestYear--;
        } else {
            lowestMonth--;
        }
        let newMontItem = this.monthColumnPlan.addMonth(lowestYear, lowestMonth, true);
        if (newMontItem == null) {
            console.warn("month cant be added, since it already exists???");
            return;
        }
        let parentContainer = this.monthColumnPlan.monthContainer;
        if (parentContainer.childElementCount > 1) {
            //wir verschieben das element nach links
            parentContainer.insertBefore(newMontItem.domNode, parentContainer.firstChild);
            this.MonthScrollBar.scrollTo({
                top: 0, //top sollte eigentlich immer 0 sein
                left: 0,
                behavior: 'smooth',
            });
        }
    }
    _onClick_ButtonAddMonthToRight() {
        let highestYear = -9999;
        let highestMonth = -99;
        //allgemeiner reminder fuer mich selber: in js fangen monate mit 0 an
        for (let cMonth of this.monthColumnPlan.getAllMonths()) { //wir suchen zuerst das jahr, dann den monat
            if ((cMonth.getCurrentYear() >= highestYear)) {
                if (cMonth.getCurrentYear() > highestYear) {
                    highestYear = cMonth.getCurrentYear();
                }
            }
        }
        for (let cMonth of this.monthColumnPlan.getAllMonths()) {
            if ((cMonth.getCurrentYear() == highestYear)) {
                if ((cMonth.getCurrentMonth() > highestMonth)) {
                    highestMonth = cMonth.getCurrentMonth();
                }
            }
        }
        if (highestMonth == -99) {
            console.warn("keine monate in liste");
            return;
        }
        //wir berechnen das neue monat und fuegen es hinzu
        if (highestMonth == 11) {
            highestMonth = 0;
            highestYear++;
        } else {
            highestMonth++;
        }
        let newMontItem = this.monthColumnPlan.addMonth(highestYear, highestMonth, true);
        if (newMontItem == null) {
            console.warn("month cant be added, since it already exists???");
            return;
        }
        //da elemente immer rechts eingefuegt werden, muessen wir nichts mit den dom-nodes machen
        this.MonthScrollBar.scrollTo({
            top: 0, //top sollte eigentlich immer 0 sein
            left: this.MonthScrollBar.scrollWidth - this.MonthScrollBar.clientWidth,
            behavior: 'smooth',
        });
    }

    private flagMinimalModeWasActive = false;
    private _onHandle_ActivateMinimalMode(toggle: boolean) {
        if (toggle == true) {
            this.flagMinimalModeWasActive = true;
            if (this.sectionWithFilterPanel.classList.contains("w3-hide") == false) {
                this.sectionWithFilterPanel.classList.add("w3-hide");
            }
            if (this.menuBarContainer.classList.contains("w3-hide") == false) {
                this.menuBarContainer.classList.add("w3-hide");
            }
        } else {
            if (this.sectionWithFilterPanel.classList.contains("w3-hide") == true) {
                this.sectionWithFilterPanel.classList.remove("w3-hide");
            }
            if (this.menuBarContainer.classList.contains("w3-hide") == true) {
                this.menuBarContainer.classList.remove("w3-hide");
            }
        }
        this.monthColumnPlan.emit("useMinimalMode", toggle);
    }

    private _onHandle_MinimalModeToggleEmptyDays(t: boolean) {
        this.monthColumnPlan.emit("minimalModeToggleShowEmptyDays", t);
    }

    // Life cycle -----------------------------------------------------//

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.storageLocationKey = location.pathname + "_" + this.id + "_saveView"; //setzt key zum laden der view

        this.getAllGroups();

        this.monthColumnPlan.on("MonthColumn/monthDateChange", lang.hitch(this, function (monthItem: MdsLax<InstanceType<typeof MonthColumn>>) {
            this.isDirty = true;
        }))

        this._chekcWebUserRole(); // setzt editable attr. Es wird hinten nochmals gecheckt, spar dir die Mühe, HTML Hacker :-)
        this._topics.push(topic.subscribe("/Session/Open", lang.hitch(this, this._chekcWebUserRole)));
        this._topics.push(topic.subscribe("/Session/CheckForExistingSession", lang.hitch(this, this._chekcWebUserRole)));

        this.processSubscriptions(this.monthColumnPlan);

        // finderBase Zeug
        this.loadFinderConfigUrl = "MonthColumnPlan/GetFilterpanelOptions";
        this.firstLoadFilterPanel();
        //this.btnSubmitLabelText = this.translations["AddressFinder_BtnSubmit"];


        // aktualisiert die anzeige und löst dadurch das darstellen der monate und tage aus

        this.startDate = new Date();

        this.setDefaultStartDate();

        //this.setTitles(window.translations["NavigationTile__MonthColumnPlan"]);

        //funny print stuff
        let hideList = document.querySelectorAll("#topBar_layout, #dynamicSidebar, #mainFooter");
        if (typeof hideList != 'undefined') {
            if (hideList != null) {
                if (hideList.length > 0) {
                    for (let elem of hideList as any as Array<HTMLElement>) {
                        if (elem.classList.contains("hideOnPrint") == false) {
                            elem.classList.add("hideOnPrint");
                        }
                    }
                }
            }
        }
        window.addEventListener("afterprint", lang.hitch(this, this._onAfterPrint));
        this.on("useMinimalMode", lang.hitch(this, this._onHandle_ActivateMinimalMode));
        this.on("minimalModeToggleShowEmptyDays", lang.hitch(this, this._onHandle_MinimalModeToggleEmptyDays));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MonthColumnPlanManager);
